import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { WhoWeArePage } from './pages/WhoWeArePage';
import { PracticeAreasPage } from './pages/PracticeAreasPage';
import { RegionalFocusPage } from './pages/RegionalFocusPage';
import { InsightsPage } from './pages/InsightsPage';
import { MarketAccessPage } from './pages/MarketAccessPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-cream font-sans text-navy selection:bg-gold/30 selection:text-navy flex flex-col" data-id="element-2">
        <Header data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/who-we-are" element={<WhoWeArePage data-id="element-9" />} data-id="element-8" />
            <Route path="/practice-areas" element={<PracticeAreasPage data-id="element-11" />} data-id="element-10" />
            <Route path="/regional-focus" element={<RegionalFocusPage data-id="element-13" />} data-id="element-12" />
            <Route path="/insights" element={<InsightsPage data-id="element-15" />} data-id="element-14" />
            <Route path="/inquiry" element={<MarketAccessPage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <Footer data-id="element-18" />
      </div>
    </BrowserRouter>;
}